export default import.meta.ROLLDOWN_FILE_URL_$5C54BCfkQLbGZSsrgZkyg